'use es6';

import { Text } from 'foundations-components/components/Text';
import PortalIdParser from 'PortalIdParser';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import I18n from 'I18n';
import { getFullUrl } from 'hubspot-url-utils';
import { jsx as _jsx } from "react/jsx-runtime";
const DefaultDeprecationMessage = ({
  message,
  dashboardId
}) => /*#__PURE__*/_jsx(Text, {
  textAlign: "center",
  children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: `reporting-reports.deprecation.${message}`,
    options: {
      urlBase: getFullUrl('app'),
      dashboardId: I18n.SafeString(dashboardId),
      portalId: I18n.SafeString(PortalIdParser.get())
    }
  })
});
export default DefaultDeprecationMessage;